import React from 'react';
import WorkingTime from "./WorkingTime";

const Workspace = () => {
    return (
        <div className="Workspace">
            <WorkingTime />
        </div>
    );
};

export default Workspace;